export const SET_MENU_SELECTED = 'MENU/selected';
export const SET_MENU_SELECTED_2 = 'MENU/selected_2';
export const SET_MENU_FOCUS_FACILITY = 'MENU/focusFacility';

export const setMenuSelected = (menu) => {
  return (dispatch) => {
    dispatch({ type: SET_MENU_SELECTED, payload: menu });
  };
};

export const setMenuSelected_2 = (menu) => {
  return (dispatch) => {
    // console.log('menu: ', menu)
    dispatch({ type: SET_MENU_SELECTED_2, payload: menu });
  };
};

export const setFocusFacility = (key) => {
  return (dispatch) => {
    dispatch({ type: SET_MENU_FOCUS_FACILITY, payload: key });
  };
};



// WEBPACK FOOTER //
// ./src/@redux/actions/menuAction.js